<div style="background-color: whitesmoke" class="p-3 h-100" fxLayout="column">
  <div class="container-fluid p-0 mb-2">
  <form class="row" *ngIf="showSearchBar">
    <div class="col-sm-12  col-md-6 col-lg-3">
<!--      <mat-form-field appearance="outline" class="w-100 filterDropdown" size="small">-->
        <mat-select class="filterDropdown" placeholder="Select Filter Type" [formControl]="dropDownSelection" (selectionChange)="dropDownSelectionChange()">
          <mat-option *ngFor="let option of dropDownOptions" [value]="option.value">
            {{option.label}}
          </mat-option>
        </mat-select>
<!--      </mat-form-field>-->
    </div>
    <div class="col-sm-12  col-md-6 col-lg-4" fxLayout="row">
      <input *ngIf="dropDownSelection.value != 'facilityNumber'" class="form-control" [disabled]="!dropDownSelection.value" mdbInput type="text" (keyup)="search($event)" name="searchValue" [(ngModel)]="searchValue" [placeholder]="getDropdownLabel()" #input>
      <input *ngIf="dropDownSelection.value == 'facilityNumber'" class="form-control" [disabled]="!dropDownSelection.value" mdbInput type="text" [placeholder]="getDropdownLabel()" name="searchValue" [(ngModel)]="searchValue">
      <button mat-flat-button color="primary" class="search-btn ml-2" [disabled]="!dropDownSelection.value || !searchValue || searchValue.length < 5" *ngIf="dropDownSelection.value == 'facilityNumber'" (click)="searchFacilityNumber()">Search</button>
    </div>
<!--    <div class="col-sm-12  col-md-3 col-lg-3">-->
<!--      <input class="form-control" mdbInput type="text" placeholder="Search by Quote Number" formControlName="quoteNumber">-->
<!--    </div>-->
<!--    <div class="col-sm-12  col-md-3 col-lg-3">-->
<!--      <input class="form-control" mdbInput type="text" placeholder="Search by Legal Entity Name" formControlName="legalEntityName">-->
<!--    </div>-->
  </form>
</div>
  <div [style]="{backgroundColor: '#54B4D3', color: 'white', textAlign: titleAlign}" class="p-2">
    <h2>{{appTitle}}</h2>
  </div>
<!--  <p class="mt-2 mb-0" *ngIf="!showOnlyFavorites">*Requires refreshed pricing. Contact your sales representative.</p>-->
<!--  <div class="mat-elevation-z8">-->
  <div class="xScroll mt-2" fxFlex="1">

    <table mat-table [dataSource]="actives" matSort matSortActive="favorite" matSortDirection="desc" class="table table-striped table-hover headerTextNowrap">
      <ng-container matColumnDef="opportunityName">
        <th mat-header-cell *matHeaderCellDef mat-sort-header>Opportunity Name</th>
        <td mat-cell *matCellDef="let row">{{row.opportunityName}}</td>
      </ng-container>
      <ng-container matColumnDef="quoteNumber">
        <th mat-header-cell *matHeaderCellDef mat-sort-header>Quote Number</th>
        <td mat-cell *matCellDef="let row">{{row.quoteNumber}}</td>
      </ng-container>
      <ng-container matColumnDef="versionDate">
        <th mat-header-cell *matHeaderCellDef mat-sort-header>Version Date & Time</th>
        <td mat-cell *matCellDef="let row">{{row.versionDate | date: 'MM/dd/YYYY hh:mm:ss a'}}</td>
      </ng-container>
      <ng-container matColumnDef="customerName">
        <th mat-header-cell *matHeaderCellDef mat-sort-header>Legal Entity Name</th>
        <td mat-cell *matCellDef="let row">{{row.customerName}}</td>
      </ng-container>
      <ng-container matColumnDef="startDate">
        <th mat-header-cell *matHeaderCellDef mat-sort-header>Start Date</th>
        <td mat-cell *matCellDef="let row">{{row.startDate | date: "MM/dd/YYYY"}}</td>
      </ng-container>
      <ng-container matColumnDef="termsLabel">
        <th mat-header-cell *matHeaderCellDef mat-sort-header>Terms (Months)</th>
        <td mat-cell *matCellDef="let row">{{row.termsLabel}}</td>
      </ng-container>
      <ng-container matColumnDef="brokerMargin">
        <th mat-header-cell *matHeaderCellDef mat-sort-header>Margin ($/MWh)</th>
        <td mat-cell *matCellDef="let row">{{row.brokerMargin | number: '1.2-2'}}</td>
      </ng-container>
      <ng-container matColumnDef="utility">
        <th mat-header-cell *matHeaderCellDef mat-sort-header>Utility</th>
        <td mat-cell *matCellDef="let row">{{row.utility}}</td>
      </ng-container>
      <ng-container matColumnDef="facilityCount">
        <th mat-header-cell *matHeaderCellDef mat-sort-header>Facility Count</th>
        <td mat-cell *matCellDef="let row">{{row.facilityCount}}</td>
      </ng-container>
      <ng-container matColumnDef="creditStatus">
        <th mat-header-cell *matHeaderCellDef mat-sort-header>Credit Status</th>
        <td mat-cell *matCellDef="let row">{{row.creditStatus}}</td>
      </ng-container>
      <ng-container matColumnDef="favorite" sticky>
        <th mat-header-cell *matHeaderCellDef mat-sort-header>Favorite</th>
        <td mat-cell *matCellDef="let row">
          <button [ngClass]="{'favorite-btn': true, 'active': row.favorite}" mat-icon-button (click)="addQuoteToFavorite(row); $event.stopImmediatePropagation()" aria-label="Favorite"><app-favorite-icon [favorite]="row.favorite"></app-favorite-icon></button>
<!--          <button mat-mini-fab *ngIf="!row.favorite" (click)="row.favorite = !row.favorite; $event.stopImmediatePropagation()" aria-label="Unfavorite"><mat-icon>star_border</mat-icon></button>-->
        </td>
      </ng-container>
<!--      <ng-container matColumnDef="isActive" sticky>-->
<!--        <th mat-header-cell *matHeaderCellDef mat-sort-header>Active</th>-->
<!--        <td mat-cell *matCellDef="let row">-->
<!--          <app-active-icon [active]="!utilService.isQuoteExpired(row.versionDate)"></app-active-icon>-->
<!--        </td>-->
<!--      </ng-container>-->
      <tr mat-header-row *matHeaderRowDef="displayedColumns; sticky: true"></tr>
      <tr mat-row *matRowDef="let row; columns: displayedColumns" (click)="openDetailDialog(row)" [ngClass]="{'expired': !showOnlyFavorites && utilService.isQuoteExpired(row.versionDate)}"></tr>
      <tr class="mat-row no-data-row" *matNoDataRow>
        <td class="mat-cell" [colSpan]="displayedColumns.length">No Data Available</td>
      </tr>
    </table>
    <div class="loadingShade" *ngIf="isLoading">
      <mat-spinner></mat-spinner>
    </div>
  </div>
    <mat-paginator [pageSizeOptions]="[10,25,100]"></mat-paginator>
</div>
